import Image from '@tiptap/extension-image'
import {mergeAttributes} from "@tiptap/react";

const RichTextInlineImage = Image.extend({
    parseHTML() {
        return [
            {
                tag: 'div[data-align]',
                getAttrs: (element) => {
                    const img = element.querySelector('img');

                    if (!img) {
                        return false;
                    }

                    return {
                        src: img.getAttribute('src'),
                        alt: img.getAttribute('alt'),
                        title: img.getAttribute('title'),
                        align: element.getAttribute('data-align'),
                    };
                },
            },
        ];
    },
    addAttributes() {
        return {
            ...this.parent?.(),
            align: {
                default: 'center',
                parseHTML: element => element.getAttribute('data-align'),
                renderHTML: attributes => ({
                    'data-align': attributes.align,
                    'style': 'text-align: center',
                    'class': 'tiptap-img-section',
                }),
            },
        };
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'div',
            { 'data-align': HTMLAttributes['data-align'], 'style': HTMLAttributes['style'], 'class': HTMLAttributes['class'] },
            ['img', mergeAttributes(HTMLAttributes, { 'data-align': null })]
        ];
    },
    addCommands() {
        return {
            ...this.parent?.(),
            setImageAlign: (align) => ({ commands }) => {
                return commands.updateAttributes('image', { align });
            },
        };
    },
})

export default RichTextInlineImage;